document.addEventListener("DOMContentLoaded", function () {

    const openBtn = document.getElementById("open-new-brand-fields");
    const addSection = document.querySelector(".add-new-brand-profile");
    const addBtn = document.getElementById("add-new-brand");
    const group = document.querySelector(".brand-profile-group");

    // Toggle form
    openBtn?.addEventListener("click", function () {
        addSection.classList.toggle("d-none");

        const input = addSection.querySelector("#brand-logo-input");
        if (input) input.value = "";
    });

    // Add new brand
    addBtn?.addEventListener("click", function () {
        const fileInput = addSection.querySelector("#brand-logo-input");

        if (!fileInput.files.length) {
            alert("Please select a logo.");
            return;
        }

        const file = fileInput.files[0];

        // Create preview item
        const newItem = document.createElement("div");
        newItem.className = "brand-item d-flex align-items-center gap-3";

        newItem.innerHTML = `
      <div class="form-element">
        <input type="file" name="brand_logo[]" accept="image/*">
      </div>
      <button type="button" class="btn-delete"><span class="icon icon-delete"></span></button>
    `;

        // Copy selected file into new input
        const newInput = newItem.querySelector('input[type="file"]');
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        newInput.files = dataTransfer.files;

        group.insertBefore(newItem, openBtn);

        fileInput.value = "";
        addSection.classList.add("d-none");
    });

    // Delete
    document.body.addEventListener("click", function (e) {
        const btn = e.target.closest(".btn-delete");
        if (!btn) return;

        const item = btn.closest(".brand-item");
        if (item) item.remove();
    });

});